class AppBlockWithTabs {
    constructor(place) {
        this.triggers = place.querySelectorAll('[data-app-block-tab-trigger]')
        this.contents = place.querySelectorAll('[data-app-block-tab-content]')
        this.contentDiv = place.querySelector('.b-app-block-with-tabs-content')
        if (
            (this.triggers.length === this.contents.length) &&
            (this.triggers.length !== 0) &&
            (this.contents.length !== 0)
        ) {
            this.setHeightBasedOnContent()
            window.addEventListener('resize', () => {
                    this.setHeightBasedOnContent()
                    this.init()
            })
            this.init()
        }
    }

    init() {
        this.hide()
        this.show(0)
        this.triggersListenerClick()
    }

    setHeightBasedOnContent() {
        if (window.innerWidth > 1024) {
            let maxHeightContent = 0;
            this.contents.forEach((contentDiv) => {
                contentDiv.classList.remove('d-none')
                maxHeightContent = Math.max(maxHeightContent, parseInt(contentDiv.clientHeight))
            })
            this.contentDiv.style.height = `${maxHeightContent + 2}px`;
        } else if (this.contentDiv.getAttribute('style')) {
            this.contentDiv.setAttribute('style', this.contentDiv.getAttribute('style').replace(/height:(.*);/, ''))
        }
    }

    triggersListenerClick() {
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].addEventListener('click', e => {
                this.triggersHandlerClick(i)
                window.scroll(window.scrollX, window.scrollY + 1);
            })
        }
    }

    triggersHandlerClick(index) {
        this.hide()
        this.show(index)
    }

    show(index) {
        this.triggers[index].classList.add('active')
        this.contents[index].classList.remove('d-none')
    }

    hide() {
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].classList.remove('active')
            this.contents[i].classList.add('d-none')
        }
    }

    toggle(index) {
        this.hide()
        this.show(index)
    }
}

let appBlockWithTabsInit = () => {
    let allCustomTabsPlace = document.querySelectorAll('[data-app-block-tab-place]')
    if (allCustomTabsPlace.length > 0) {
        for (let i = 0; i < allCustomTabsPlace.length; i++) {
            new AppBlockWithTabs(allCustomTabsPlace[i])
        }
    }
}
appBlockWithTabsInit()